// extracted by mini-css-extract-plugin
export default {"section":"onboardingSuccess_section__asqNp"};